export default __webpack_public_path__ + "static/media/barn.153d8f5a.png";